import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '../translate';

@Component({
  selector: 'wego-image-popup',
  template: `
  <div bsModal #imageModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" 
  aria-labelledby="mySmallModalLabel" aria-hidden="true"  [config]="{backdrop: false, keyboard: false}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header" style="border: none;">
                <button type="button" class="close" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{{ popupTitle }}</h4>
            </div>
            <div class="modal-body" style="height: 100%;min-height: 100%;text-align: center;">           
                 <img *ngIf="imagepath" [src]="imagepath"  style="max-width: 100%;max-height: 100%;"> 
            </div>            
        </div>
    </div>
  </div>`
})

export class ImagePopupComponent implements OnInit, OnDestroy {
  _popupTitle: string = this.translate.instant('LblConfirm');

  @ViewChild('imageModal') public confirmModal: ModalDirective;

  constructor(private translate: TranslateService) { }

  @Input('imagepath') imagepath: string;

  ngOnInit() {
  }

  public show() {
    this.confirmModal.show();
  }

  public hide() {
    this.confirmModal.hide();
  }

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/popup/image-popup.component.ts